export default __webpack_public_path__ + "static/media/Rabbet Budget Template.23d11405.xlsx";